import { useEffect, useRef, useState } from "react";

/**
 * Barra de progresso para a busca de GPS.
 * O tempo de um fix de GPS é imprevisível (2s a 20s), então a barra avança de forma
 * assintótica até 92% e só completa 100% quando a ação REALMENTE termina (`active`
 * vira false) — nunca mostra "cheio" antes do fim de verdade.
 */
export function GeoProgressBar({ active, expectedMs = 12000, testId = "geo-progress" }) {
  const [pct, setPct] = useState(0);
  const [visible, setVisible] = useState(false);
  const startedAt = useRef(0);

  useEffect(() => {
    if (active) {
      setVisible(true);
      setPct(4);
      startedAt.current = Date.now();
      const id = setInterval(() => {
        const t = (Date.now() - startedAt.current) / expectedMs;
        setPct(Math.min(92, 4 + 88 * (1 - Math.exp(-2.2 * t))));
      }, 120);
      return () => clearInterval(id);
    }
    if (!visible) return undefined;
    setPct(100);
    const id = setTimeout(() => { setVisible(false); setPct(0); }, 550);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, expectedMs]);

  if (!visible) return null;

  return (
    <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden" data-testid={testId}>
      <div
        className="h-full bg-[#FF6B35] rounded-full"
        style={{ width: `${pct}%`, transition: "width 180ms linear" }}
        data-testid={`${testId}-bar`}
      />
    </div>
  );
}

export default GeoProgressBar;
